import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import { Title, MainIcon, IconWrapper } from '../../SharedStyles'
import TileSmall from './TileSmall'

const NewValuePropositionSmall = ({
  asset,
  title,
  className,
  ...props
}) =>
  <TileSmall className={ className } { ...props } >
    <IconWrapper className="small-tile-icon-wrapper">
      <MainIcon className="small-tile-icon" asset={ asset } />
    </IconWrapper>
    <CustomTitle className="small-tile-title">{ title }</CustomTitle>
  </TileSmall>

NewValuePropositionSmall.propTypes = {
  asset: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string
}

export default NewValuePropositionSmall

const CustomTitle = styled(Title)`
  margin-top: 25px;
  ${Mixin.font.GothamBold(18)};

  @media (max-width: 500px) {
    ${Mixin.font.GothamBold(16)};
    margin-top: 10px;
  }

  @media (max-width: 400px) {
    ${Mixin.font.GothamBold(11)};
  }
`
